<ng-container *ngIf="priceMode">
    <p
        class="product-item-price__original-price"
        *ngIf="showExchangePrice"
        [innerText]="cashPrice | defaultcurrency"
    ></p>

    <h4
        class="product-item-price__call-for-price"
        *ngIf="priceMode === 'call for price'"
        [innerText]="'generic.call_for_price' | translate"
    ></h4>

    <h4
        class="product-item-price__cash-price"
        *ngIf="priceMode === 'cash price'"
        [innerText]="(showExchangePrice ? cashPriceExchanged : cashPrice) | defaultcurrency"
    ></h4>

    <ng-container *ngIf="priceMode === 'leasing terms'">
        <h4 class="product-item-price__leasing-price">
            {{ leasingPriceFormatted }}/{{ 'generic.month_abbreviation' | translate }}
        </h4>

        <h6
            class="product-item-price__vat-notice"
            *ngIf="showVatNotice"
            [innerText]="'generic.vat_excluded' | translate"
        ></h6>

        <p class="product-item-price__leasing-details">
            {{ 'filterpage.product_card_car_downpayment_text_prefix' | translate }}
            {{ downPaymentPrice | defaultcurrency }}
        </p>

        <p class="product-item-price__leasing-details">
            {{ 'filterpage.product_card_car_monthlyterm_text_prefix' | translate }}
            {{ leasingDuration }}
            {{ 'generic.months' | translate }}
        </p>
    </ng-container>

    <p
        class="product-item-price__exchange-car-disclaimer"
        *ngIf="showExchangePrice"
        [innerText]="'filterpage.exchange_car_facet____product_card_disclaimer_text' | translate"
    ></p>

    <p
        *ngIf="showLoanPrice"
        class="product-item-price__loan-details"
    >
        {{ 'filterpage.product_card_car_loan_text_prefix' | translate }}
        {{ loanPrice | defaultcurrency }}/{{ 'generic.month_abbreviation' | translate }}
    </p>
</ng-container>
